export default __webpack_public_path__ + "static/media/showroom29.dc94a1fc.jpg";